import { SelectItem } from 'app/shared/models/select-item.type';
import {
	VehicleRoadTaxRecordCategoryEnum,
	VehicleRoadTaxStatusEnum,
	vehicleRoadTaxStatusToColor,
} from '@splitsecondconnect/ultramarine-shared';

import { FEATURES } from '../../../../core/features/features';

export const VEHICLE_ROAD_TAX_STATUSES: SelectItem<VehicleRoadTaxStatusEnum>[] =
	[
		{
			value: VehicleRoadTaxStatusEnum.ACTIVE,
			displayValue: 'road-taxes|status|active',
			pillColor: vehicleRoadTaxStatusToColor(VehicleRoadTaxStatusEnum.ACTIVE),
		},
		{
			value: VehicleRoadTaxStatusEnum.PENDING,
			displayValue: 'road-taxes|status|pending',
			pillColor: vehicleRoadTaxStatusToColor(VehicleRoadTaxStatusEnum.PENDING),
		},
		{
			value: VehicleRoadTaxStatusEnum.EXPIRED,
			displayValue: 'road-taxes|status|expired',
			pillColor: vehicleRoadTaxStatusToColor(VehicleRoadTaxStatusEnum.EXPIRED),
		},
	];

export const ROAD_TAX_RECORD_CATEGORIES: SelectItem<VehicleRoadTaxRecordCategoryEnum>[] =
	[
		{
			value: VehicleRoadTaxRecordCategoryEnum.VEHICLE,
			displayValue: 'road-taxes|record-category|vehicle',
			disabled: !FEATURES.vehicles,
		},
	];
